import type { FaireProductEntity } from "../../entity_types/product";

export const p_my2xj2rcvg: FaireProductEntity = {
  token: "p_my2xj2rcvg",
  type: "product",
  name: "IMMORTAL FLOWER STAINLESS STEEL RINGS FOR WOMEN_CWAJE0610",
  brandToken: "b_3eopd3scey",
  brandName: "ACCITY",
  imageUrl:
    "https://cdn.faire.com/fastly/0b2a633f6f8b8f1a3eae57e5908c720cfaf71b3e66450d7cbbefa73cf468f9d6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/684aaa83ddac91d2c894b773164ea22bff7ac43f03ffbb0b14cd8b2f07427c4f.jpeg",
    "https://cdn.faire.com/fastly/a9729db4945cbd8ac380be726b1832761e0f5581449f6104fd9633a26b48c431.jpeg",
    "https://cdn.faire.com/fastly/c55a0eed6dfc123a74a9febd07cce2a5487b9c32a3ccf5926ae6870ff363fd26.jpeg",
    "https://cdn.faire.com/fastly/1b8dfc282426b79d29632acde83d70442aa82524c5957564073f30104461ab33.jpeg",
    "https://cdn.faire.com/fastly/1c3bb7c9c8df2f5ae19a1e5c5cdb4c4fc573a4a48645114b4d698863541d7a67.jpeg",
    "https://cdn.faire.com/fastly/188545b21a6b8548a9a30d5b08c93493b54170bfef9a2d7b2091afac80ac4f11.jpeg",
    "https://cdn.faire.com/fastly/e34057a60cabeabb08875db34c9061fde107a2b7bb8597a865c6f4a25cf9345f.jpeg",
    "https://cdn.faire.com/fastly/85c386ae744dc352319a0e03e5dcab84ef1b674d92dc2276be4658169c0f0b4f.jpeg",
    "https://cdn.faire.com/fastly/4ab04c4fc0efa68062c4bd98f353ac115d5d63126ca49839bdedb8d5f8525d7c.jpeg",
    "https://cdn.faire.com/fastly/54a42261c149d20ae3fff4d6267b1215f64aefa9bfc65a8bcf69c0ef8bdac4f4.jpeg",
    "https://cdn.faire.com/fastly/66d8da339f7542956cbe1796b188cbc77bfd3a26976dfda6a73cc0a42009ea72.jpeg",
    "https://cdn.faire.com/fastly/6bb7e4642192f1f7c23684c89e569d01113c6408571fde113b95094c99d29b95.jpeg",
    "https://cdn.faire.com/fastly/7bddc5096624c0abf2644fcec53626240d5c1f1ff23151148c927cc68d720639.jpeg",
  ],
  priceDollars: 7.64,
  description:
    "IMMORTAL FLOWER STAINLESS STEEL RINGS FOR WOMEN\nSIZE:OS(3) SPLIT RING\n100% STAINLESS STEEL\nMADE IN CHINA",
  tags: [],
  msrpDollars: 15.27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:19.168Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
